/**
 * EnableUserModal - Modal for enabling disabled user accounts
 */
export default function EnableUserModal({
  show,
  onClose,
  user,
  onEnable,
  loading,
}) {
  if (!show || !user) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[60] flex items-center justify-center p-4">
      <div className="bg-card border border-emerald-500/30 rounded-xl max-w-md w-full p-6 space-y-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-emerald-500/10 border border-emerald-500/20 rounded-lg flex items-center justify-center">
            <svg className="w-6 h-6 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-foreground">Enable User Account</h3>
        </div>
        
        <p className="text-muted-foreground">
          Are you sure you want to re-enable the account for <strong>{user.name}</strong> ({user.email})?
        </p>
        
        <p className="text-sm text-muted-foreground">
          The user will be able to log in and use the platform again.
        </p>

        <div className="flex gap-3">
          <button
            onClick={onEnable}
            disabled={loading}
            className="flex-1 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 text-white rounded-lg transition font-medium"
          >
            {loading ? "Enabling..." : "Enable Account"}
          </button>
          <button
            onClick={onClose}
            disabled={loading}
            className="flex-1 px-4 py-2 bg-muted hover:bg-muted/80 disabled:opacity-50 text-foreground rounded-lg transition"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
